export default {
      id: "star-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#star",
      toString: function () {
        return this.url;
      }
    }